import React from 'react'

import '../CSS/about.css';
function About() {
    return (
        <div className='container' id="about">
            <h2>קצת עלינו</h2>
            <p className='text' id="aboutUs">
                .<span id="underline"> צימר רוני - צימר המותאם לזוגות</span>, נמצא בגני מודיעין צמוד לקרית ספר <br />
                ,במתחם שלנו יש בריכה ענקית מחוממת בנויה בגודל 20/4, הבריכה מקורה וצנועה<br />
                .גינה גדולה, חדר כושר, סאונה רטובה ויבשה, ושולחן פינג פונג<br />
                .בכל צימר יש ג'קוזי, מקרר, כיריים, מטבחון, פלטה ומיחם לשבת
            </p>
        </div>
    )
}

export default About


